import _ from 'lodash';
import { getPinLocation } from '../LayoutCanvas/PortsCanvas';
import _LayoutData from '../data/LayoutData';
import CeLayoutDB from '../CeLayoutDB/CeLayoutDB';

const MAX_PIN_TEXI_LIMIT = 100, MAX_PIN_LIMIT = 1000;
function getPortData(designData, chip, PowerNets, ReferenceNets, SignalNets = [], notDisplaySignal) {

  if (!designData) {
    return { data: null, layerList: [], powerPins: {}, referencePins: {}, signalPins: {}, showPinList: [], pinLocationList: [] }
  }

  const {
    mGeomHolder,
    mLayerMgr,
    mLayoutSettings,
    mNetManager,
    mPartMgr,
    mProfile,
    mSymbolMgr,
    mUnits
  } = designData

  SignalNets = SignalNets ? SignalNets : [];


  // filter mNetManager
  const netObj = netManagerHandle(mNetManager, chip, PowerNets, ReferenceNets, SignalNets, notDisplaySignal);
  const { pinList, powerPins, referencePins, signalPins } = netObj;

  // filter mLayerMgr
  const layerObj = mLayerMgrHandle(mLayerMgr, chip, PowerNets, ReferenceNets, pinList, SignalNets, { referencePins, powerPins });
  const { partList, layerList, showPinList, pinLocationList, gridData } = layerObj;

  // filter mPartMgr
  const partMgr = mPartMgrHandle(mPartMgr, pinList, partList);

  // Set new data
  const newData = new CeLayoutDB();
  newData.SetData({
    mGeomHolder,
    mLayerMgr: layerObj.mLayerMgr || mLayerMgr,
    mLayoutSettings,
    mNetManager: netObj.mNetManager || mNetManager,
    mPartMgr: partMgr || mPartMgr,
    mProfile,
    mSymbolMgr,
    mUnits
  })
  return { data: newData, layerList, powerPins, referencePins, signalPins, showPinList, pinLocationList, gridData };
}

function netManagerHandle(netManager, chip, PowerNets, ReferenceNets, SignalNets, notDisplaySignal) {
  const mNetManager = _.cloneDeep(netManager);
  const indexList = [], powerPins = {}, referencePins = {}, pinList = [], signalPins = {};
  if (mNetManager && mNetManager.mNetList) {
    let displayNetList = notDisplaySignal ? [] : [...PowerNets, ...SignalNets]
    mNetManager.mNetList.mKeys.forEach((item, index) => {
      if ([...displayNetList].includes(item)) {
        indexList.push(index);
      }
    })
    const judgeComp = (pin) => (pin.mCompName === chip || (Array.isArray(chip) && chip.includes(pin.mCompName)));
    mNetManager.mNetList.mVals.forEach(item => {
      if (PowerNets.includes(item.mName)) {
        const pins = item.mPinList.filter(pin => judgeComp(pin)).map(p => p.mPinNum);
        pinList.push(...pins);
        powerPins[item.mName] = [...pins];
      } else if (ReferenceNets.includes(item.mName)) {
        const pins = item.mPinList.filter(pin => judgeComp(pin)).map(p => p.mPinNum);
        pinList.push(...pins);
        referencePins[item.mName] = [...pins];
      } else if (SignalNets.includes(item.mName)) {
        const pins = item.mPinList.filter(pin => judgeComp(pin)).map(p => p.mPinNum);
        pinList.push(...pins);
        signalPins[item.mName] = [...pins];
      }
    })
    // const mVals = mNetManager.mNetList.mVals.filter((key, index) => indexList.includes(index));
    // mNetManager.mNetList.mVals = mVals;
    mNetManager.mNetList.mKeys = [];
    mNetManager.mNetList.mVals = [];
    return { mNetManager, pinList, powerPins, referencePins, signalPins }
  }
  return { mNetManager: null, powerPins: {}, referencePins: {}, pinList: [], signalPins: {} }
}

function mLayerMgrHandle(layerMgr, chip, PowerNets, ReferenceNets, pinList, SignalNets, pinLimit = {}) {
  const newMatalLayers = [], layerList = new Set(), partList = [], pinLocationList = [];
  const CompSet = new Set([...(Array.isArray(chip) ? chip : [chip]), ...PowerNets, ...ReferenceNets, ...SignalNets]);
  const pinSet = new Set(pinList);
  const { referencePins, powerPins } = pinLimit;
  let showPinList = [];
  let gridData = {}
  const mLayerMgr = _.cloneDeep(layerMgr);
  for (let layer of mLayerMgr.mMetalLayers) {
    const mComponentLayer = layer.mComponentLayer;
    const mNetGeomList = layer.mNetGeomList;
    if (mComponentLayer && mComponentLayer.mComponents) {
      const mComponents = mComponentLayer.mComponents.filter(item => CompSet.has(item.mName));
      mComponents.forEach(item => {
        if (item.mName === chip || (Array.isArray(chip) && chip.includes(item.mName))) {
          item.mPinsLocationList = item.mPinsLocationList.filter(pin => pinSet.has(pin.pinNumber));
          pinLocationList[item.mName] = item.mPinsLocationList;
          if (PowerNets && PowerNets.length) {
            const powerPinSet = new Set(PowerNets.flatMap(net => powerPins[net] || []));
            const keepPowerPins = item.mPinsLocationList.filter(pin => powerPinSet.has(pin.pinNumber)).map(pin => ({ ...pin, type: 'Power' }));
            if (keepPowerPins.length > MAX_PIN_LIMIT) {
              const refPinSet = new Set(ReferenceNets.flatMap(net => referencePins[net] || []));
              const keepReferencePins = item.mPinsLocationList.filter(pin => refPinSet.has(pin.pinNumber)).map(pin => ({ ...pin, type: 'Ground' }));
              const keepPins = getPinsAreaByPins({ pins: keepReferencePins, basePins: keepPowerPins });
              showPinList.push(...keepPins.map(pin => ({ name: item.mName, pin: pin.pinNumber, type: pin.type })))
              gridData = buildPinGrid({ pins: [...keepPowerPins, ...keepReferencePins], maxNumber: MAX_PIN_LIMIT, name: item.mName });
            }
          }
        }
        partList.push(item.mPart.mInfo.mPartName);
        item.mPart.mPinList = item.mPart.mPinList.filter(item => pinSet.has(item.mNumber))
      })
      mComponentLayer.mComponents = mComponents
      if (mComponentLayer.mComponents.length) {
        layerList.add(mComponentLayer.mName);
        layerList.add(layer.mName);
        // let indexList = [];
        // mNetGeomList.mKeys.forEach((item, index) => {
        //   if (CompSet.has(item)) {
        //     indexList.push(index);
        //   }
        // })
        // mNetGeomList.mKeys = mNetGeomList.mKeys.filter((item, index) => indexList.includes(index));
        // mNetGeomList.mVals = mNetGeomList.mVals.filter((item, index) => indexList.includes(index));
        mNetGeomList.mKeys = [];
        mNetGeomList.mVals = [];
        newMatalLayers.push(layer)
      }
    }
  }
  mLayerMgr.mMetalLayers = newMatalLayers;
  const layerListArray = Array.from(layerList);
  const newNameMap = _.cloneDeep(mLayerMgr.mLayerIDNameMap);
  let indexList = new Set();
  mLayerMgr.mLayerIDNameMap.mVals.forEach((item, index) => {
    if (layerList.has(item)) {
      indexList.add(index);
    }
  })
  newNameMap.mVals = mLayerMgr.mLayerIDNameMap.mVals.filter((item, index) => indexList.has(index));
  newNameMap.mKeys = mLayerMgr.mLayerIDNameMap.mKeys.filter((item, index) => indexList.has(index));
  mLayerMgr.mLayerIDNameMap = newNameMap;
  return { mLayerMgr, layerList: layerListArray, partList, showPinList, pinLocationList, gridData }
}

function mPartMgrHandle(partMgr, pinList, partList) {
  const mPartMgr = _.cloneDeep(partMgr);
  const newPartList = [], newFootList = []
  const pinSet = new Set(pinList);
  const partSet = new Set(partList);
  const mFutprtList = new Set();
  mPartMgr.mPartList.forEach(item => {
    if (partSet.has(item.mInfo.mPartName)) {
      item.mPinList = item.mPinList.filter(pin => pinSet.has(pin.mNumber));
      item.mFutprtList.mValues.forEach(id => mFutprtList.add(id));
      newPartList.push(item);
    }
  })
  mPartMgr.mPartList = newPartList;
  mPartMgr.mFootprintList.forEach(item => {
    if (mFutprtList.has(item.mID)) {
      const mMetalLayerList = item.mMetalLayerList;
      mMetalLayerList.forEach(m => {
        m.mPadList = m.mPadList.filter(pad => pinSet.has(pad.mPadID));
      })
      item.mMetalLayerList = mMetalLayerList;
      newFootList.push(item)
    }
  })
  mPartMgr.mFootprintList = newFootList;
  return mPartMgr
}

function autoGrouping({ pinInfo = [], rate = 5, extra = false }) {
  const groups = [];
  let pinSort = _.cloneDeep(pinInfo);
  // for pin group
  while (pinSort.length) {
    let groupNumber = [];
    let pinMain = pinSort.shift();
    groupNumber.push({ ...pinMain });
    if (!pinSort.length) {
      groups.push([pinMain].map(item => ({ ...item, groupIndex: groups.length + 1 })));
    } else {
      let aroundPins = getPinsByDistance({ pinMains: [pinMain], pinList: pinSort, rate });
      let aroundInfo = pinSort.filter(item => aroundPins.includes(item.pinNumber));
      groupNumber.push(...aroundInfo);
      if (extra && aroundPins.length) {
        pinSort = pinSort.filter(item => !aroundPins.includes(item.pinNumber));
        while (aroundPins.length && pinSort.length) {
          let aroundPins = getPinsByDistance({ pinMains: [...aroundInfo], pinList: pinSort, rate });
          if (!aroundPins.length) break;
          aroundInfo = pinSort.filter(item => aroundPins.includes(item.pinNumber));
          groupNumber.push(...aroundInfo);
          pinSort = pinSort.filter(item => !aroundPins.includes(item.pinNumber));
          if (!pinSort.length) break;
        }
      }

      groups.push(groupNumber.map(item => ({ ...item, groupIndex: groups.length + 1 })));
    }
  }

  return groups
}

/**
 * 
 * @param {array} pinMains [{pinInfo}]
 * @param {array} pinList [{pinInfo}]
 * @param {number} rate expand range
 * @return {array} distGroup ? [{pinInfo}] : [pinNumber]
 */

function getPinsByDistance({ pinMains, pinList, rate = 5, distGroup = false, typeGroup = false }) {
  let _pinList = _.cloneDeep(pinList);
  let pins = [], distGroups = [];
  for (let pinMain of pinMains) {
    // group pin rate * r
    const { xc, yc, r } = pinMain;
    const x = Number(xc), y = Number(yc);
    let _location = _pinList.map(item => {
      let distance = Infinity;
      const _x = Number(item.xc), _y = Number(item.yc);
      distance = Math.sqrt(Math.pow(x - _x, 2) + Math.pow(y - _y, 2))
      return { distance, ...item }
    }).sort((a, b) => a.distance > b.distance ? 1 : -1);
    if (distGroup) {
      distGroups.push(_location.map(l => ({ distance: l.distance, pinNumber: l.pinNumber })));
    } else {
      const matchedPins = [];
      const pinSet = new Set();
      for (const item of _location) {
        if (item.distance < rate * r) {
          if (typeGroup) {
            matchedPins.push({ pin: item.pinNumber, type: item.type });
          } else {
            matchedPins.push(item.pinNumber);
          }
          pinSet.add(item.pinNumber);
        }
      }
      pins.push(...matchedPins);
      _pinList = _pinList.filter(item => !pinSet.has(item.pinNumber));
    }
  }
  return distGroup ? distGroups : pins
}

function getReferenceArea(powerGroup, refeInfo, rate) {
  let splitPin = [], refeGroups = [];

  let refePins = _.cloneDeep(refeInfo)

  for (let power of powerGroup) {
    const xPower = power.sort((a, b) => a.xc > b.xc ? 1 : -1);
    const xMin = xPower[0].xc - xPower[0].r * rate, xMax = xPower[xPower.length - 1].xc + xPower[xPower.length - 1].r * rate;
    const yPower = power.sort((a, b) => a.yc > b.yc ? 1 : -1);
    const yMin = yPower[0].yc - yPower[0].r * rate, yMax = yPower[yPower.length - 1].yc + yPower[yPower.length - 1].r * rate;
    // find midpoint
    const xc = (xMin + xMax) / 2, yc = (yMin + yMax) / 2;
    let main = { xc: xc, yc: yc, r: xMax - xc > yMax - yc ? xMax - xc : yMax - yc }
    let refeGroup = getPinsByDistance({ pinMains: [main], pinList: refePins, rate: 1 });
    let _rate = 2;
    while (!refeGroup.length && _rate < 5) {
      refeGroup = getPinsByDistance({ pinMains: [main], pinList: refePins, rate: _rate });
      _rate = _rate + 1;
    }
    refeGroup = refeGroup.filter(pin => !splitPin.includes(pin))
    splitPin.push(...refeGroup);
    refeGroups.push(refeInfo.filter(pin => refeGroup.includes(pin.pinNumber)));
  }
  return refeGroups;
}

function addNewPinToUsedGroup(pins, usedRefe) {
  let _usedRefe = [...usedRefe], findIndexs = [], exist = false;
  for (let pin of pins) {
    let findIndex = _usedRefe.findIndex(pinList => pinList.includes(pin));
    if (findIndex > -1) {
      exist = true;
      if (_usedRefe[findIndex].length >= 2) {
        findIndex = 'not add new';
      }
    }
    findIndexs.push(findIndex);
  }
  if (!exist) {
    _usedRefe.push(pins);
  } else {
    let newGroup = [], isDeleted = [];
    findIndexs.forEach((find, index) => {
      if (find !== 'not add new') {
        const _find = find - isDeleted.length;
        if (_find > -1) {
          if (!isDeleted.includes(_find)) {
            newGroup.push(..._usedRefe[_find]);
            _usedRefe.splice(_find, 1);
            isDeleted.push(_find)
          }
        } else {
          newGroup.push(pins[index])
        }
      }
    })
    newGroup = [...new Set(newGroup)];
    if (newGroup.length) {
      _usedRefe.push(newGroup);
    }
  }
  return _usedRefe;
}

function autoSplitRefeByPower(powerInfo, refeInfo, refeGroup, findPinLocation = true) {
  // get location
  let _powerInfo = powerInfo.map(pin => {
    const info = findPinLocation ? getPinLocation(pin) : undefined;
    if (!info) return { xc: null, yc: null, r: null, ...pin }
    const { x, y, r } = info;
    return { ...pin, xc: x, yc: y, r }
  })
  let _refeInfo = refeInfo.map(pin => {
    const info = findPinLocation ? getPinLocation(pin) : undefined;
    if (!info) return { xc: null, yc: null, r: null, ...pin }
    const { x, y, r } = info;
    return { ...pin, xc: x, yc: y, r }
  })

  const powerGroup = autoGrouping({ pinInfo: _powerInfo, extra: true, rate: 10 });
  for (let i = 0; i < powerGroup.length; i++) {
    const refePins = getReferenceArea([powerGroup[i]], _refeInfo, 15)[0];
    let usedRefe = [...refeGroup];
    if (!refePins.length) {
      powerGroup[i].forEach(pin => pin.refePins = []);
      continue;
    }
    const eachLocation = getPinsByDistance({ pinMains: powerGroup[i], pinList: refePins, distGroup: true });
    powerGroup[i].forEach((pin, index) => {
      const curLocation = eachLocation[index];
      const minDistance = curLocation[0].distance;
      const minPins = curLocation.filter(item => item.distance === minDistance).map(item => item.pinNumber);
      pin.minPin = minPins[0];
      usedRefe = addNewPinToUsedGroup(minPins, usedRefe);
    })
    powerGroup[i].forEach((pin, index) => {
      pin.refePins = usedRefe.find(pinList => pinList.includes(pin.minPin));
    })
    const allUsed = usedRefe.flat(2);
    _refeInfo = _refeInfo.filter(item => !allUsed.includes(item.pinNumber))
  }
  const _powerGroup = powerGroup.flat(2);
  return _powerGroup;
}

function getCenter(pins, pinMap) {
  if (!pins.length) return null;
  let sumX = 0, sumY = 0;
  pins.forEach(pin => {
    const { xc, yc } = pinMap.get(pin);
    sumX += xc;
    sumY += yc;
  });
  return { xc: sumX / pins.length, yc: sumY / pins.length };
}

function getDiePortsByPloc({
  packageId,
  component,
  PowerNets,
  ReferenceNets,
  cpmPins,
  pinMatching = 'center'
}) {
  const DesignData = _LayoutData.getLayout(packageId);
  const filterData = getPortData(DesignData, component, PowerNets, ReferenceNets)
  const { powerPins, referencePins, data: PCBData } = filterData;
  const powers = Object.values(powerPins).flat(2), refe = Object.values(referencePins).flat(2);
  const pinsInfo = PCBData.getComponent(component).mPinsLocationList.map(pin => ({ ...pin, ...pin.mLocation }));
  const powerGroups = {}
  const referenceGroups = {}
  const pinMap = new Map(pinsInfo.map(pin => [pin.pin, { xc: Number(pin.xc), yc: Number(pin.yc) }]));//key: pin, value: {xc, yc}
  cpmPins.forEach(item => {
    const { net, csmNet, pin, portName } = item
    if (PowerNets.includes(net) && powers.includes(pin)) {
      if (!powerGroups[portName]) {
        powerGroups[portName] = []
      }
      powerGroups[portName].push(pin)
    } else if (ReferenceNets.includes(net) && refe.includes(pin)) {
      if (!referenceGroups[portName]) {
        referenceGroups[portName] = []
      }
      referenceGroups[portName].push(pin)
    }
  });

  const powerGroupsList = Object.keys(powerGroups).map(groupName => ({
    name: groupName,
    pins: powerGroups[groupName].slice(),
    center: getCenter(powerGroups[groupName], pinMap)
  }));

  const referenceGroupsList = Object.keys(referenceGroups).map(groupName => ({
    name: groupName,
    pins: referenceGroups[groupName].slice(),
    center: getCenter(referenceGroups[groupName], pinMap)
  }));

  const ports = [];
  let portId = 1;
  for (const powerGroup of powerGroupsList) {
    let nearestReferenceGroup = null;
    let minDistance = Infinity;
    let matchedPins = [];

    if (pinMatching === "center") {
      for (const referenceGroup of referenceGroupsList) {
        const distance = Math.hypot(
          powerGroup.center.xc - referenceGroup.center.xc,
          powerGroup.center.yc - referenceGroup.center.yc
        );
        if (distance < minDistance) {
          minDistance = distance;
          nearestReferenceGroup = referenceGroup;
        }
      }
    } else if (pinMatching === "single") {
      for (const powerPin of powerGroup.pins) {
        const { xc: powerX, yc: powerY } = pinMap.get(powerPin);
        for (const referenceGroup of referenceGroupsList) {
          for (const referencePin of referenceGroup.pins) {
            const { xc: refX, yc: refY } = pinMap.get(referencePin);
            const distance = Math.hypot(powerX - refX, powerY - refY);
            if (distance < minDistance) {
              minDistance = distance;
              nearestReferenceGroup = referenceGroup;
              matchedPins = [{ powerPin, referencePin }];
            }
          }
        }
      }
    }

    if (nearestReferenceGroup) {
      ports.push({
        port: String(portId++),
        portName: powerGroup.name,
        referenceGroup: nearestReferenceGroup.name,
        powerPins: powerGroup.pins.slice(),
        referencePins: nearestReferenceGroup.pins.slice(),
      });
    }
  }
  return { ports, powerGroupsList, referenceGroupsList };
}

function getMergePortData(designData, chips, ReferenceNets, SignalNets = []) {
  const mNetManager = designData.mNetManager;
  // chip: {referencePins, signalPins}
  const pinObj = {};
  if (mNetManager && mNetManager.mNetList) {
    const judgeComp = (pin) => chips.includes(pin.mCompName);
    mNetManager.mNetList.mVals.forEach(item => {
      if (ReferenceNets.includes(item.mName)) {
        for (const pin of item.mPinList) {
          if (judgeComp(pin)) {
            if (pinObj[pin.mCompName] && pinObj[pin.mCompName].referencePins && pinObj[pin.mCompName].referencePins[item.mName]) {
              pinObj[pin.mCompName].referencePins[item.mName].push(pin.mPinNum)
            } else if (pinObj[pin.mCompName] && pinObj[pin.mCompName].referencePins) {
              pinObj[pin.mCompName].referencePins[item.mName] = [pin.mPinNum];
            } else {
              pinObj[pin.mCompName] = { referencePins: { [item.mName]: [pin.mPinNum] } }
            }
          }
        }
      } else if (SignalNets.includes(item.mName)) {
        for (const pin of item.mPinList) {
          if (judgeComp(pin)) {
            if (pinObj[pin.mCompName] && pinObj[pin.mCompName].signalPins && pinObj[pin.mCompName].signalPins[item.mName]) {
              pinObj[pin.mCompName].signalPins[item.mName].push(pin.mPinNum)
            } else if (pinObj[pin.mCompName] && pinObj[pin.mCompName].signalPins) {
              pinObj[pin.mCompName].signalPins[item.mName] = [pin.mPinNum];
            } else {
              pinObj[pin.mCompName] = { signalPins: { [item.mName]: [pin.mPinNum] } }
            }
          }
        }
      }
    })

    return pinObj;
  }
  return {}
}

function getPinsAreaByPins({ pins, basePins }) {
  let boundary = { minX: Infinity, minY: Infinity, maxX: - Infinity, maxY: - Infinity }
  basePins.forEach(pin => {
    const canvasPin = pin.canvasObj;
    if (!canvasPin) return { xc: null, yc: null, r: null, ...pin }
    const info = getPinLocation(canvasPin);
    if (!info) return { xc: null, yc: null, r: null, ...canvasPin, type: pin.type }
    const { x, y } = info;
    if (x < boundary.minX) {
      boundary.minX = x;
    } else if (x > boundary.maxX) {
      boundary.maxX = x;
    }

    if (y < boundary.minY) {
      boundary.minY = y;
    } else if (y > boundary.maxY) {
      boundary.maxY = y;
    }
  })

  let newPins = pins.map(pin => {
    const canvasPin = pin.canvasObj;
    if (!canvasPin) return { xc: null, yc: null, r: null, ...pin }
    const info = getPinLocation(canvasPin);
    if (!info) return { xc: null, yc: null, r: null, ...canvasPin, type: pin.type }
    const { x, y, r } = info;
    return { ...canvasPin, xc: x, yc: y, r, type: pin.type }
  })

  let filterPins = [], expansion = 0;
  while (!filterPins.length) {
    expansion = expansion + 0.1;
    const padX = expansion * (boundary.maxX - boundary.minX);
    const padY = expansion * (boundary.maxY - boundary.minY);
    const newBoundary = { minX: boundary.minX - padX, maxX: boundary.maxX + padX, minY: boundary.minY - padY, maxY: boundary.maxY + padY }
    filterPins = newPins.filter(item => {
      const { xc, yc } = item;
      if (!xc || !yc) return false;
      return xc < newBoundary.maxX && xc > newBoundary.minX && yc < newBoundary.maxY && yc > newBoundary.minY
    })
  }

  return [...filterPins, ...basePins];
}

function buildPinGrid({ pins, maxNumber, name }) {
  const pinInfos = pins
    .map(pin => {
      const info = pin.canvasObj && getPinLocation(pin.canvasObj);
      if (!info) return null;
      return {
        ...pin,
        xc: info.x,
        yc: info.y,
        pin: pin.pinNumber,
        type: pin.type
      };
    })
    .filter(Boolean);

  if (pinInfos.length === 0) return null;

  const powerPins = pinInfos.filter(p => p.type === 'Power');
  if (powerPins.length === 0) return null;

  const xs = powerPins.map(p => p.xc);
  const ys = powerPins.map(p => p.yc);
  const xMin = Math.min(...xs), xMax = Math.max(...xs);
  const yMin = Math.min(...ys), yMax = Math.max(...ys);

  const aspectRatio = (xMax - xMin) / (yMax - yMin);
  const gridCountY = Math.round(Math.sqrt(maxNumber / aspectRatio)) || 1;
  const gridCountX = Math.round(maxNumber / gridCountY) || 1;

  const gridWidth = (xMax - xMin) / gridCountX;
  const gridHeight = (yMax - yMin) / gridCountY;

  const gridMap = new Map();
  const showPins = [];

  for (let gx = 0; gx < gridCountX; gx++) {
    for (let gy = 0; gy < gridCountY; gy++) {
      const key = `${gx}_${gy}`;
      const minX = xMin + gx * gridWidth;
      const maxX = xMin + (gx + 1.1) * gridWidth;
      const minY = yMin + gy * gridHeight;
      const maxY = yMin + (gy + 1.1) * gridHeight;

      const pinsInCell = pinInfos.filter(p =>
        p.xc >= minX && p.xc <= maxX &&
        p.yc >= minY && p.yc <= maxY
      ).map(p => ({
        name,
        pin: p.pin,
        type: p.type,
        xc: p.xc,
        yc: p.yc
      }));

      if (pinsInCell.length) {
        gridMap.set(key, pinsInCell);
        const leftTop = pinsInCell.reduce((nearest, p) => {
          const dx = p.xc - minX, dy = p.yc - minY;
          const dist = dx * dx + dy * dy;
          return !nearest || dist < nearest.dist ? { pin: p, dist } : nearest;
        }, null);
        if (leftTop) {
          showPins.push({
            name: leftTop.pin.name,
            pin: leftTop.pin.pin,
            type: leftTop.pin.type
          });
        }
      }
    }
  }

  return {
    gridMap,
    showPins,
    gridCountX,
    gridCountY,
    gridWidth,
    gridHeight,
    xMin,
    yMin
  };
}

export {
  getPortData,
  autoGrouping,
  autoSplitRefeByPower,
  getDiePortsByPloc,
  getMergePortData,
  MAX_PIN_TEXI_LIMIT,
  MAX_PIN_LIMIT
}